import { Box, Flex } from 'components/elements'
import { DetailContainer, DetailWrapper, DetailedCard, InfoColumn, MainWrapCSS } from 'features/incidents/components/style'
import { styled } from '@stitches/react'
import { PlanReviewSummaryProps } from '../type'
import { useEffect, useState, useMemo } from 'react'
import { routes, serviceArrayAssessment, serviceLableAssessments } from 'configs/constants'
import FormWrapper from 'features/auth/components/FormWrapper'
import { Form, userRegHeadingCss } from 'views/style'
import { Button } from 'components/button/Button'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { BorderCss } from './PlanSelection'
import { BackNavArrowIcon } from 'components/icons'
import { Stages } from 'utils/enum'
// import { TotalDiscountApplied } from 'utils/function'
// import { calculateDiscount } from './ServiceFormBase'
import { QouteLayout } from 'features/quote/page/GetAQuotes'
import { buttonCss } from './CoveragePlan'
import { ReviewTermsConditionComp } from 'features/customLandingPage/component/AffiliateUserQuoteReview'
import QuoteReviewModal from './QuoteReviewModal'
import { TERMINOLOGY } from 'utils/enum'

const QuoteReview = (prop: PlanReviewSummaryProps) => {
  const [hasServices, setHasServices] = useState('')
  const [openModal, setOpenModal] = useState(false)
  const [hasDiscount, setHadDiscount] = useState(false)
  const services = useMemo(() => {
    return (prop?.quoteUserReg && prop.quoteUserReg.service) || []
  }, [prop?.quoteUserReg])

  const secondaryServices = services.filter(item => item !== prop?.quoteUserReg?.primaryService?.id)
  const navigate = useNavigate()
  const totalDiscount = (prop?.quoteUserReg && prop?.quoteUserReg.discount) || 0

  useEffect(() => {
    const d = prop?.quoteUserReg?.premiumInfo?.discountPercent
    if (d && d > 0) {
      setHadDiscount(true)
      setHasServices(d.toString())
    }
  }, [prop.quoteUserReg, secondaryServices, services, totalDiscount])
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const { handleSubmit, control, setValue } = useForm()
  const onSubmit = () => {
    if (openModal) {
      prop?.setStage && prop.setStage(Stages.STAGE7)
    } else setOpenModal(true)
  }
  const handleAccept = () => {
    setValue('terms', true)
    setOpenModal(false)
    prop?.setStage && prop.setStage(Stages.STAGE7)
  }
  return (
    <>
      <Flex align="start" justify="center" css={{ ...QouteLayout, mt: '$12', mb: '$12' }}>
        <Flex justify="between" css={{ mb: 0 }}></Flex>
        <FormWrapper controlWidth={{ maxWidth: 700 }}>
          <Flex align="center" css={{ alignItems: 'center' }}>
            <BackNavArrowIcon fontSize={24} style={{ cursor: 'pointer' }} onClick={() => prop?.setStage && prop.setStage(Stages.STAGE4)} />

            <Flex as="h2" justify={'center'} css={userRegHeadingCss}>
              Quote Review
            </Flex>
          </Flex>

          <Form onSubmit={handleSubmit(onSubmit)}>
            <Box css={{ textAlign: 'left' }}>
              <Box as="p" css={{ fontSize: '1rem', fontWeight: '$normal', color: '$gray4' }}>
                Based on your selection, following are your {TERMINOLOGY.warranty.singular.toLowerCase()} details
              </Box>

              <Box className="detail-box" style={{ padding: 0 }} css={{ ...MainWrapCSS, background: '$cardGradient', borderRadius: '8px' }}>
                <DetailedCard css={{ maxWidth: 'none', marginBottom: 0 }}>
                  <Flex justify="start" direction="column">
                    <DetailWrapper css={{ border: 'none', p: 0 }}>
                      <Flex justify={'between'} wrap={'wrap'} css={{ mb: '$3' }}>
                        <Box as="h4" css={{ textAlign: 'start', m: 0 }}>
                          {TERMINOLOGY.warranty.singular} details
                        </Box>
                        {hasDiscount && (
                          <Notification>
                            <Box as="span" css={{ textAlign: 'center' }}>
                              You saved {hasServices}%
                            </Box>
                          </Notification>
                        )}
                      </Flex>
                      <DetailContainer css={BorderCss}>
                        <InfoColumn css={BoxCss}>
                          <Box as="p" className="t-title  m-0 t-box">
                            {TERMINOLOGY.warranty.singular}
                          </Box>
                          <Box as="p" className={`t-value `} css={textCss}>
                            {prop?.quoteUserReg?.planName}
                          </Box>
                        </InfoColumn>
                        <InfoColumn css={BoxCss}>
                          <Box as="p" className="t-title  m-0">
                            {TERMINOLOGY.benefit.singular}
                          </Box>
                          <Box as="p" className={`t-value `} css={textCss}>
                            ${prop?.quoteUserReg?.premiumInfo?.maxCoverage}
                          </Box>
                        </InfoColumn>
                        <InfoColumn css={BoxCss}>
                          <Box as="p" className="t-title  m-0">
                            Original Premium{' '}
                          </Box>
                          <Box as="p" className={`t-value `} css={textCss}>
                            ${prop?.quoteUserReg?.premiumInfo?.premium}
                          </Box>
                        </InfoColumn>
                        <InfoColumn css={BoxCss}>
                          <Box as="p" className="t-title  m-0">
                            Discounted Premium
                          </Box>
                          <Box as="p" className={`t-value `} css={{ ...textCss, color: '$primary', fontSize: '$xl' }}>
                            ${prop?.quoteUserReg?.premiumInfo?.discountValue}
                          </Box>
                        </InfoColumn>
                      </DetailContainer>
                    </DetailWrapper>
                  </Flex>
                  <Flex justify={'start'} direction={'column'} css={{ mt: '$5' }}>
                    <Box as="h3" css={{ textAlign: 'start', fontSize: '1rem', fontWeight: '$normal', color: '$white', margin: 0 }}>
                      Monitoring services
                    </Box>
                    <Box css={{ textAlign: 'start' }}>
                      <Flex direction={'column'} wrap={'wrap'}>
                        {services?.map((item, idx) => {
                          const serviceName = serviceArrayAssessment[item - 1]
                          return (
                            <Flex direction={'row'} key={idx} wrap={'wrap'} css={{ width: '100%', padding: '.5rem' }}>
                              <Box as="span" css={{ fontWeight: '$normal', flexBasis: '40%', color: '$gray5' }}>
                                {serviceLableAssessments[serviceName]}
                              </Box>
                              <Box as="span" css={{ flexBasis: '50%' }}>
                                {serviceName}
                              </Box>
                            </Flex>
                          )
                        })}
                      </Flex>
                    </Box>
                  </Flex>
                </DetailedCard>
              </Box>
            </Box>
            <ReviewTermsConditionComp control={control} setOpenModal={setOpenModal} />

            <Box css={buttonCss}>
              <Button bordered={true} type="button" onClick={() => navigate(routes.login)}>
                Cancel
              </Button>
              <Button type="submit">Proceed To Payment</Button>
            </Box>
          </Form>
        </FormWrapper>
        <QuoteReviewModal openModal={openModal} setOpenModal={setOpenModal} handleAccept={handleAccept} />
      </Flex>
    </>
  )
}
export const Notification = styled(Box, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center',
  height: 'fit-content',
  background: '$primary',
  borderRadius: '90px',
  padding: ' 7px 15px',
})
export const BoxCss = {
  marginBottom: 0,
  maxWidth: '200px',
  width: '100%',
  padding: '1rem 1.5rem',
}
export const textCss = {
  fontSize: '$base',
  fontWeight: '$semibold',
  wordBreak: 'break-word !important',
}
export default QuoteReview
